import React, { useState, useEffect } from "react";
import Select from "react-select";
import CurrencyHeader from "./CurrencyHeader";
import CurrencyBody from "./CurrencyBody";
import countryCurrencies from "../../utils/countryToCurrency.json";
import CurrencyConverter from "./CurrencyConverter";
import currencies from "../SelectCurrency/currencies.json";

const fetchExchangeRates = async () => {
  const response = await fetch("https://fxservices.vercel.app/api/forex-rates");
  const data = await response.json();
  return data;
};

const CurrencyRates = ({ title }) => {
  const [exchangeRates, setExchangeRates] = useState([]);
  const [sources, setSources] = useState([]);
  const [uniqueCurrencies, setUniqueCurrencies] = useState([]);
  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filteredCurrency, setFilteredCurrency] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  useEffect(() => {
    const getExchangeRates = async () => {
      const data = await fetchExchangeRates();
      setExchangeRates(data);
      setSources(data.map((currency) => currency.source));
      setRates(data.map((d) => d.rates));
      setLoading(false);

      const allCurrencies = [
        ...new Set(Object.values(countryCurrencies)),
      ].sort();

      setUniqueCurrencies(allCurrencies);
    };

    getExchangeRates();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      window.location.reload();
    }, 10800000); // 3 hours in milliseconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  const handleFilterCountry = (currency) => {
    const filteredValue = uniqueCurrencies.filter(
      (curr) => curr.toLowerCase() === currency.toLowerCase()
    );

    setFilteredCurrency(filteredValue);
  };

  const handleSelectChange = (data) => {
    setSelectedCurrency(data);
    if (data) {
      handleFilterCountry(data.value);
    }
  };

  const clearFilter = () => {
    setFilteredCurrency([]); // Clear filtered currencies
    setSelectedCurrency(null); // Reset selected currency
  };

  return (
    <div>
      {loading ? (
        <i className="fa fa-spinner"></i>
      ) : (
        <div className="admin_exchange_rate_cont">
          <CurrencyConverter currencies={uniqueCurrencies} />
          <div className="admin_exchange_rate_table">
            <div className="admin_exchange_header_cont">
              <h2>Exchange Rates</h2>
              <div className="admin_exchange_filter_country">
                <Select
                  options={currencies}
                  className="admin_filter_select"
                  placeholder="Filter by Country"
                  value={selectedCurrency}
                  onChange={(data) => handleSelectChange(data)}
                />
                <button onClick={clearFilter}> Clear Filter</button>
              </div>

              <button
                className="admin_exchange_refresh_all"
                onClick={() => window.location.reload()}
              >
                <i className="fa fa-refresh" aria-hidden="true"></i>Refresh All
              </button>
            </div>
            <table>
              <CurrencyHeader sources={sources} />
              <CurrencyBody
                currency={
                  filteredCurrency.length > 0
                    ? filteredCurrency
                    : uniqueCurrencies
                }
                rates={rates}
              />
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrencyRates;
